import React, { useState } from 'react';
import { Row, Col, Container, Form, FormControl, InputGroup, Button } from 'react-bootstrap';
//Utils
import { formPost } from '../../../utils/api';
import { eventGA } from '../../../utils/ga';
//Components
import ModalAlert from '../../../components/modal_alert/modal_alert';
//Images
import Wave from '../../../img/wave-shap.svg';
//CSS
import './style.css';
//
export default function Home(props){
    const [fields, setFields] = useState({});
    const [showMessage, setShowMessage] = useState(false);
    //
    //Handlers
    function handleField(event){
        let newFields = fields;
        newFields[event.target.name] = event.target.value;
        setFields(newFields);
    }
    function handleSubmit(event){
        eventGA('Home_Top_Form', 'Formulário primário da Landing Page enviado.');
        formPost('/Home_Top_Form', fields);
        setShowMessage(true);
        event.preventDefault();
    }
    //
    //Renders
    return(
        <>
        <ModalAlert title="Envio de Contato" message="Mensagem Enviada com Sucesso!" isShow={showMessage} onClick={()=>setShowMessage(false)}/>
        <section id={props.id} className="home-background-img pt-5" style={{backgroundImage: `url(${props.image})`}}>
            <Container>
                <Row className="justify-content-between">
                    <Col md={6} lg={6}>
                        <div className="hero-content-left position-relative mt-5 text-white">
                            <h1 className="text-white mb-5">{ props.title }</h1>
                            { props.text.split(' \n ').map((line, i) => <p className="lead mb-0" key={i}>{line}</p>) }
                        </div>
                    </Col>
                    <Col md={5} lg={5}>
                        <div className="sign-up-form-wrap position-relative mt-5 p-5 gray-light-bg rounded shadow">
                            <div className="sign-up-form-header text-center mb-4">
                            <h4 className="mb-0">{props.formTitle}</h4>
                            </div>
                            <div className="message-box d-none">
                                <div className="alert alert-danger"></div>
                            </div>
                            <Form onSubmit={handleSubmit} id="getQuoteFrm" className="sign-up-form">
                                <br/>
                                <Form.Group className="input-group">
                                    <InputGroup>
                                        <FormControl onChange={handleField} name="name" placeholder="Seu Nome" type="text" required />
                                    </InputGroup>
                                </Form.Group>
                                <br/>
                                <Form.Group className="input-group">
                                    <FormControl onChange={handleField} name="email" placeholder="Email" type="email" required />
                                </Form.Group>
                                <br/>
                                <Form.Group className="input-group">
                                    <FormControl onChange={handleField} name="message" id="msg" placeholder="Digite uma mensagem" as="textarea" cols="30" rows="4" required />
                                </Form.Group>
                                <br/>
                                <Form.Group className="input-group">
                                    <Button type="submit" name="submit" id="submit" className="btn solid-btn btn-block">
                                        Enviar
                                    </Button>
                                </Form.Group>
                                <br/>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>
            
            <div className="section-shape position-absolute">
                <img src={Wave} alt="shape" />
            </div>
        </section>
        </>
    );
};